/**
 * Non-persisted PLITS sample rows shown at the top of Artefacts Index preview tables.
 * Files live under `public/onboarding-sample-artefacts/` (static; Open uses new tab, not blob mammoth).
 */

const BASE = "/onboarding-sample-artefacts";

/** @type {{ id: string, fileNameWithExt: string, title: string }[]} */
export const ONBOARDING_SAMPLE_ARTEFACT_ROWS = [
  {
    id: "onb-sample-artefact-format",
    fileNameWithExt: "PLITS_TEM_Artefact Format_V1.docx",
    title: "Artefact format (sample)",
  },
];

/**
 * Absolute URL for static sample .docx (CRA `PUBLIC_URL` prefix when app not hosted at root).
 * @param {string} fileNameWithExt
 * @returns {string}
 */
export function getOnboardingSampleArtefactHref(fileNameWithExt) {
  const name = String(fileNameWithExt || "").trim();
  if (!name) return "";
  const pub = typeof process !== "undefined" && process.env && process.env.PUBLIC_URL ? String(process.env.PUBLIC_URL) : "";
  const root = pub.replace(/\/$/, "");
  const path = `${BASE}/${encodeURIComponent(name)}`;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${root}${path}`;
  }
  return `${root || ""}${path}`;
}
